import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "progress-container"
};
const _hoisted_2 = { key: 0 };
const _hoisted_3 = {
    key: 0,
    class: "personalDetails"
};
const _hoisted_4 = {
    key: 0,
    class: "well"
};
const _hoisted_5 = { class: "anchor-bottom submitControls" };
import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useBanking } from '@/composables/useBanking';
import { useContent } from '@/composables/useContent';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import InputSections from './elements/InputSections.vue';
import MGButton from './elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AddOfflineBankAccountPage',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getBankAccount, listBanks, addOfflineBankAccount, updateOfflineBankAccount, getBankingInfo } = useBanking();
        const { getAiopSection } = useContent();
        const validationText = ref(null);
        const sectionNo = ref(0);
        const currentPageNumber = ref(0);
        const sections = ref([]);
        const breadCrumb = ref([]);
        const inputSections = ref(null);
        const bankHeader = computed(() => {
            const verb = route.params.id ? 'Edit' : 'Add';
            return verb + " offline account";
        });
        const progressValue = computed(() => {
            const totalPages = sections.value.length;
            if (totalPages === 0)
                return 0;
            return ((currentPageNumber.value + 1) / totalPages) * 100;
        });
        const editMode = computed(() => {
            return route.params.id ? true : false;
        });
        // --- Helpers (inlined from Helpers mixin) ---
        function findField(fieldName) {
            for (const section of sections.value) {
                for (const field of section.fields) {
                    if (field.label === fieldName) {
                        return field;
                    }
                }
            }
            return null;
        }
        function findFieldValue(fieldName) {
            for (const section of sections.value) {
                for (const field of section.fields) {
                    if (field.label === fieldName && field.value != null) {
                        return field.value;
                    }
                }
            }
            return null;
        }
        function loadFieldsFromObject(fieldMappings) {
            Object.keys(fieldMappings).forEach(fieldName => {
                sections.value.forEach((section) => {
                    section.fields.forEach((field) => {
                        if (field.label === fieldName) {
                            field.value = fieldMappings[fieldName];
                        }
                    });
                });
            });
        }
        function sectionAllowed(section) {
            if (!section.rule) {
                return true;
            }
            const [ruleKey, ruleValue] = section.rule.split(':').map((s) => s.trim());
            const ruleValues = ruleValue.split(',').map((s) => s.trim());
            for (let i = 0; i < sectionNo.value; i++) {
                const sec = sections.value[i];
                for (const field of sec.fields) {
                    if (field.id === ruleKey && ruleValues.includes(field.value)) {
                        return true;
                    }
                }
            }
            return false;
        }
        function inputControlGoNext(onFinished = null) {
            validationText.value = '';
            let allOK = true;
            for (const field of sections.value[sectionNo.value].fields) {
                if (field.required && (!field.value || field.value === "")) {
                    validationText.value = field.validationText;
                    allOK = false;
                    break;
                }
                if (field.type === 'datetext' && field.value.length < 10) {
                    validationText.value = "Please enter date in the format dd/mm/yyyy";
                    allOK = false;
                    break;
                }
                if (field.strongPass != undefined && field.strongPass == false) {
                    validationText.value = "Your password is not strong enough";
                    allOK = false;
                    break;
                }
            }
            if (allOK) {
                let allowed = false;
                breadCrumb.value.push({ sectionNo: sectionNo.value });
                while (!allowed) {
                    validationText.value = null;
                    sectionNo.value++;
                    if (!sections.value[sectionNo.value]) {
                        if (onFinished) {
                            onFinished();
                            return;
                        }
                    }
                    else {
                        allowed = sectionAllowed(sections.value[sectionNo.value]);
                    }
                }
                currentPageNumber.value++;
                inputSections.value.next(sectionNo.value);
            }
            setTimeout(() => { validationText.value = null; }, 4000);
        }
        function inputControlGoBack() {
            const crumb = breadCrumb.value.pop();
            sectionNo.value = crumb.sectionNo;
            validationText.value = null;
            currentPageNumber.value--;
            inputSections.value.back(sectionNo.value);
        }
        // --- Page logic ---
        function populateFields(account) {
            const fieldMappings = {
                'Name of bank': account.bank.name,
                'Nickname (e.g personal account)': account.displayName,
                'Balance': account.balance,
                'Ownership': account.jointStatus === 2 ? 'Joint' : account.jointStatus === 1 ? 'Sole' : null,
                'Account number': account.accountNumber,
                'Sort code': account.sortCode,
            };
            loadFieldsFromObject(fieldMappings);
        }
        function addAccount() {
            const account = {
                accountType: "Transaction",
                jointStatus: findFieldValue('Ownership') === 'Joint' ? 2 : findFieldValue('Ownership') === 'Sole' ? 1 : null,
                customerID: state.customer.id,
                bankName: findFieldValue('Name of bank') || null,
                displayName: findFieldValue('Nickname (e.g personal account)') || null,
                balance: findFieldValue('Balance') || null,
                accountNumber: findFieldValue('Account number') || null,
                sortCode: findFieldValue('Sort code') || null,
            };
            if (route.params.id) {
                account.id = route.params.id;
                const accountType = { name: "Transaction" };
                account.accountType = accountType;
            }
            const handleResponse = (res) => {
                if (res) {
                    if (route.params.id) {
                        getBankAccount(route.params.id, null, true, true);
                    }
                    getBankingInfo(null, true);
                    router.push({ path: '/policysuccess', query: { type: 'account' } });
                }
            };
            if (!route.params.id) {
                addOfflineBankAccount(account, handleResponse);
            }
            else {
                updateOfflineBankAccount(account, handleResponse);
            }
        }
        onMounted(() => {
            getAiopSection('AddOfflineBankAccountSections.json', () => {
                sections.value = state.sectionJson;
                if (route.params.id) {
                    getBankAccount(route.params.id, (account) => {
                        populateFields(account);
                    });
                }
                getCustomer();
                listBanks((res) => {
                    const bankField = findField('Name of bank');
                    if (bankField) {
                        bankField.items = res.map((provider) => {
                            return provider.name.replace(/\w\S*/g, (txt) => {
                                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                            });
                        });
                    }
                });
            });
        });
        return (_ctx, _cache) => {
            const _component_v_progress_linear = _resolveComponent("v-progress-linear");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: bankHeader.value,
                    bgcolor: "white",
                    border: "0"
                }, null, 8, ["title"]),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).customer
                }, null, 8, ["customer"]),
                (sections.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_component_v_progress_linear, {
                            "model-value": progressValue.value,
                            rounded: ""
                        }, null, 8, ["model-value"])
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).customer)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                (sections.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                        _createVNode(InputSections, {
                                            ref_key: "inputSections",
                                            ref: inputSections,
                                            sections: sections.value,
                                            theme: "light",
                                            editMode: editMode.value
                                        }, null, 8, ["sections", "editMode"]),
                                        (validationText.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                _createElementVNode("p", null, _toDisplayString(validationText.value), 1)
                                            ]))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_5, [
                                            _createVNode(_component_v_row, null, {
                                                default: _withCtx(() => [
                                                    (currentPageNumber.value > 0)
                                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                                            key: 0,
                                                            cols: "5"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(MGButton, {
                                                                    small: "true",
                                                                    outline: true,
                                                                    onClick: _cache[0] || (_cache[0] = ($event) => (inputControlGoBack())),
                                                                    text: "Back"
                                                                })
                                                            ]),
                                                            _: 1
                                                        }))
                                                        : _createCommentVNode("", true),
                                                    _createVNode(_component_v_col, null, {
                                                        default: _withCtx(() => [
                                                            _createVNode(MGButton, {
                                                                small: currentPageNumber.value > 0,
                                                                alt: true,
                                                                text: "Next",
                                                                arrow: true,
                                                                onClick: _cache[1] || (_cache[1] = ($event) => (inputControlGoNext(addAccount)))
                                                            }, null, 8, ["small"])
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            })
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
